<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <aurora-button
          [loading]="dsCollection && dsCollection.status == 'Loading'"
          class="pull-right margin-l-5"
          type="submit"
          style="margin-top: 16px"
          variant="primary"
          (click)="auroraSubmitForm.onSubmit($event)"
        >
          Search
        </aurora-button>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #teamSetFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th>Team Set Name</th>
              <th>Description</th>
            </tr>
            <tr
              *ngFor="
                let teamSet of dsCollection.objectNodes
                  | epFilter : teamSetFilter.filter : teamSetFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(teamSet)"
            >
              <td>
                {{ teamSet.Team_Set_Name }}
              </td>
              <td>
                {{ teamSet.Team_Set_Desc }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Team Sets</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
